import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6df7b372&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6df7b372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df7b372",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df7b372')) {
      api.createRecord('6df7b372', component.options)
    } else {
      api.reload('6df7b372', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6df7b372&scoped=true&", function () {
      api.rerender('6df7b372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/index.vue"
export default component.exports